import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function SocialProofSection() {
  const stars = Array(5).fill(0);
  return <section className="py-20 px-4 relative" data-id="element-208">
      <div className="max-w-6xl mx-auto" data-id="element-209">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-4 font-orbitron" data-id="element-210">
          Experiencias <span className="neon-text-green" data-id="element-211">Reales</span>
        </h2>
        <p className="text-center text-gray-500 text-sm mb-16" data-id="element-212">
          Nota: Los resultados individuales pueden variar. Este contenido es
          educativo.
        </p>

        <div className="flex flex-col lg:flex-row gap-8 items-center" data-id="element-213">
          <div className="flex-1 space-y-8 w-full" data-id="element-214">
            {/* Testimonial 1 */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="glass-panel border-l-4 border-l-[#39FF14] rounded-r-2xl p-6 md:p-8 relative" data-id="element-215">
              <div className="flex gap-1 mb-4 text-[#39FF14]" data-id="element-216">
                {stars.map((_, i) => <StarIcon key={i} size={18} fill="currentColor" data-id="element-217" />)}
              </div>
              <p className="text-lg text-gray-300 italic mb-6" data-id="element-218">
                "Pasé de no tener control sobre mis gastos a gestionar un
                presupuesto para mis metas personales en solo 4 meses. Ahora
                tengo un sistema claro para cada moneda que recibo."
              </p>
              <div className="flex justify-between items-end flex-wrap gap-4" data-id="element-219">
                <div data-id="element-220">
                  <p className="font-bold text-white" data-id="element-221">Javier M., 16 años</p>
                </div>
              </div>
            </motion.div>

            {/* Testimonial 2 */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="glass-panel border-l-4 border-l-[#8B5CF6] rounded-r-2xl p-6 md:p-8 relative" data-id="element-222">
              <div className="flex gap-1 mb-4 text-[#39FF14]" data-id="element-223">
                {stars.map((_, i) => <StarIcon key={i} size={18} fill="currentColor" data-id="element-224" />)}
              </div>
              <p className="text-lg text-gray-300 italic mb-6" data-id="element-225">
                "Mi hija de 15 años terminó la guía en una tarde. Ahora entiende
                conceptos de inversión que yo no dominaba a su edad. Es una
                excelente base para su futuro."
              </p>
              <div className="flex justify-between items-end flex-wrap gap-4" data-id="element-226">
                <div data-id="element-227">
                  <p className="font-bold text-white" data-id="element-228">Elena R., Madre</p>
                </div>
              </div>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="flex-1 hidden lg:block" data-id="element-229">
            <img src="https://cdn.magicpatterns.com/uploads/iWDQiKrXGkfCwkNce2JiPD/prueba_social.png" alt="Ahorros creciendo" className="w-full max-w-md mx-auto drop-shadow-[0_0_50px_rgba(139,92,246,0.3)]" data-id="element-230" />
          </motion.div>
        </div>
      </div>
    </section>;
}